import { forwardRef } from 'react';
import { StyledButton } from './Button.styles';
import { ButtonContent } from './ButtonContent';
export const Button = forwardRef((props, ref) => {
    return (<StyledButton {...props} aria-busy={!!props.isLoading} ref={ref}>
        <ButtonContent {...props}/>
      </StyledButton>);
});
